module.exports = __webpack_public_path__ + "static/snake-8dd775e142dc168a12a3bf2d53835d48.gif";